import React from 'react';

import { RouteObject } from 'react-router-dom';

const PsoGasTariffs = React.lazy(
  () => import('@/pages/GasTariffs/views/PsoGasTariffs'),
);
const MarketGasPrices = React.lazy(
  () => import('@/pages/GasTariffs/views/MarketGasPrices'),
);
const PonGasPrices = React.lazy(
  () => import('@/pages/GasTariffs/views/PonGasPrices'),
);
const Tariffs = React.lazy(() => import('@/pages/GasTariffs/views/Tariffs'));
const MarginalPrices = React.lazy(
  () => import('@/pages/GasTariffs/views/MarginalPrices'),
);

export const gasTariffsDetailPath = {
  PsoGasTariffs: '',
  MarketGasPrices: 'market-prices',
  PonGasPrices: 'pon-prices',
  Tariffs: 'tariffs',
  MarginalPrices: 'marginal-prices',
};

export const gasTariffsDetailRoutes: RouteObject[] = [
  { index: true, element: <PsoGasTariffs /> },
  { path: gasTariffsDetailPath.MarketGasPrices, element: <MarketGasPrices /> },
  { path: gasTariffsDetailPath.PonGasPrices, element: <PonGasPrices /> },
  { path: gasTariffsDetailPath.Tariffs, element: <Tariffs /> },
  { path: gasTariffsDetailPath.MarginalPrices, element: <MarginalPrices /> },
];
